import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import Answer from "./Answer";
import {Alert, Button, Col, Row} from "reactstrap";

class Bpto extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tmp: 0,
      stepIndex: false,
    };

    this.incrementStep = this.incrementStep.bind(this);
    this.decrementStep = this.decrementStep.bind(this);
    this.onSelectAnswer = this.onSelectAnswer.bind(this);
    this.getCurrentValue = this.getCurrentValue.bind(this);
    this.getCountActiveAnswers = this.getCountActiveAnswers.bind(this);
  }

  decrementStep(){
    const {details} = this.props;
    const {stepIndex} = this.state;


    if(stepIndex === false){
      this.setState({
        stepIndex: details.length > 1 ? details.length-1 : 0
      });
    }else{
      if(stepIndex > 0){
        this.setState({
          stepIndex: stepIndex-1
        });
      }
    }
  }

  incrementStep(){
    const {details} = this.props;
    const {stepIndex} = this.state;

    if(stepIndex !== false){
      if(stepIndex+1 < details.length){
        this.setState({
          stepIndex: stepIndex+1
        });
      }else{
        this.setState({
          stepIndex: false
        });
      }

    }else{
      this.setState({
        stepIndex: details.length-1
      });
    }
  }

  onSelectAnswer(answer){
    if(this.getCountActiveAnswers() <= 1){
      return;
    }

    let {details, question} = this.props;
    const {stepIndex} = this.state;
    const microTime = getCurrentMicroTime(this.props.startTime);

    if(stepIndex !== false){
      details = details.slice(0, stepIndex);
    }

    details.push({
      microTime,
      answer,
      position: details.length,
      values: _.map(question.answers, answer => {
        return {answer: answer.id, value: this.getCurrentValue(answer).toFixed(2)}
      })
    });

    this.props.onDetailsUpdated(details);

    this.setState({
      stepIndex: false
    })
  }

  getCurrentValue(answer){
    const {details, question} = this.props;
    const {stepIndex} = this.state;

    let value = answer.startValue;
    _.each(details, (detail, key) => {
      if(stepIndex !== false && key >= stepIndex){
        return;
      }

      if(detail.answer === answer.id){
        if(question.changesType === 'value'){
          value += question.incrementValue;
        }else if(question.changesType === 'percentage'){
          value += value * (question.incrementValue / 100);
        }
      }else{
        if(question.changesType === 'value'){
          value -= question.decrementValue;
        }else if(question.changesType === 'percentage'){
          value -= value * (question.decrementValue / 100);
        }
      }
    });

    if(value <= answer.minValue){
      return answer.minValue;
    }
    if(value >= answer.maxValue){
      return answer.maxValue;
    }

    return value;
  }

  getCountActiveAnswers(){
    const {question, details} = this.props;
    let actives = 0;

    if(question.maxSteps > 0 && details.length >= question.maxSteps){
      return 0;
    }

    _.each(question.answers, answer => {
      const currentValue = this.getCurrentValue(answer);
      if(currentValue > answer.minValue && currentValue < answer.maxValue){
        actives++;
      }
    });


    return actives;
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if(question.required){
      if(this.getCountActiveAnswers() > 1){
        validate.errors.push(validationTexts.required);
      }
    }

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  render(){
    const {question, details} = this.props;
    const {stepIndex} = this.state;

    if(this.getCountActiveAnswers() <= 1){
      return <Alert className="success text-center mb-0">Kliknij przycisk "Dalej"</Alert>
    }

    return <React.Fragment>
      <Row>
        {question.answers.map(answer => {
          return <Col key={answer.id} xs={12} sm={6} md={4} lg={3}>
            <Answer onChoose={() => this.onSelectAnswer(answer.id)} answer={answer} value={this.getCurrentValue(answer)} question={question} />
          </Col>
        })}
      </Row>
      <hr />
      <Row>
        <Col xs={12} sm={4} md={3}>
          {/*<Button*/}
          {/*  disabled={details.length === 0 || stepIndex === 0}*/}
          {/*  color="primary"*/}
          {/*  size="sm"*/}
          {/*  className="w-100"*/}
          {/*  onClick={() => this.decrementStep()}*/}
          {/*>Cofnij</Button>*/}
        </Col>
        <Col className="text-center d-flex align-items-center" xs={12} sm={4} md={6}>
          <span className="mx-auto">
            {'Krok '}
            {stepIndex !== false ? stepIndex+1 : details.length+1}{stepIndex !== false && '/' + (details.length+1)}
            {question.maxSteps > 0 && ' z ' + question.maxSteps}
          </span>
        </Col>
        <Col xs={12} sm={4} md={3}>
          {/*<Button*/}
          {/*  disabled={stepIndex === false}*/}
          {/*  color="primary"*/}
          {/*  size="sm"*/}
          {/*  className="w-100"*/}
          {/*  onClick={() => this.incrementStep()}*/}
          {/*>Dalej</Button>*/}
        </Col>
      </Row>
    </React.Fragment>
  }
}

Bpto.propTypes = {
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    microTime: PropTypes.number,
    answer: PropTypes.number.isRequired,
  }).isRequired),
  changePage: PropTypes.func.isRequired,
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      maxValue: PropTypes.number.isRequired,
      minValue: PropTypes.number.isRequired,
      startValue: PropTypes.number.isRequired,
    }).isRequired,).isRequired,
    content: PropTypes.string.isRequired,
    changesType: PropTypes.oneOf(['value', 'percentage']).isRequired,
    currency: PropTypes.string.isRequired,
    decrementValue: PropTypes.number.isRequired,
    incrementValue: PropTypes.number.isRequired,
    maxSteps: PropTypes.number.isRequired,
    required: PropTypes.bool.isRequired,
  }).isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Bpto);